import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Row, Col, Card, Badge } from 'react-bootstrap';
import HtmlHead from 'components/html-head/HtmlHead';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// external
import { motion } from 'framer-motion';
// utils
import { handleCatchError, handleAPIError, handlerErrors } from 'utils/handleErrors';
// API
import { getPlugins } from '../../../api/Api-user';

const Integrations = () => {
  const title = 'Integraciones';
  const description = 'Integraciones Autopaquete';
  const history = useHistory();
  const [plugins, setPlugins] = useState([]);

  const PluginCards = ({ item }) => {
    return (
      <Col md="6" lg="4" className="">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.5 }}
        >
          {/* hover-border-primary */}
          <Card className="h-100 sh-md-40">
            <Card.Body>
              {!item.state && (
                <Badge pill bg="primary" className="me-1 position-absolute e-n2 t-2 z-index-1 font-patrick icon-14">
                  Próximamente
                </Badge>
              )}
              <div className="text-center">
                <img src={item.icon} alt="icon" className="bg-infox" width="140px" height="140px" />
                <div className="d-flex flex-column sh-5">
                  {item.state ? (
                    <NavLink to={`/integraciones/documentacion/${item.name}`} className="heading stretched-link">
                      {item.name}
                    </NavLink>
                  ) : (
                    <span className="heading text-muted">{item.name}</span>
                  )}
                </div>
              </div>
              <div className="text-muted text-center">Consulta nuestra documentación para configurar {item.name}.</div>
            </Card.Body>
          </Card>
        </motion.div>
      </Col>
    );
  };
  const handlerGetPlugins = async () => {
    try {
      const response = await getPlugins();
      // console.log('Integraciones response:', response);
      if (response.length > 0) {
        const reducedPlugins = response.map((element) => ({
          icon: element.service_icon_with_base_url,
          name: element.name,
          state: element.is_active,
        }));
        // Obtener lo que ya existe en localIntegrationsState
        const prev = JSON.parse(localStorage.getItem('localIntegrationsState')) || {};
        // Guardar la nueva data combinada
        const updated = {
          ...prev,
          localPlugins: reducedPlugins,
          pluginsInfo: response, // it will be use in template page to render each plugin page
        };

        localStorage.setItem('localIntegrationsState', JSON.stringify(updated));
        // Actualiza el estado
        setPlugins(reducedPlugins);
      }
    } catch (error) {
      handlerErrors(error);
    }
  };
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('localIntegrationsState'));
    if (storedData?.localPlugins) {
      setPlugins(storedData.localPlugins);
    }
    handlerGetPlugins();
  }, []);
  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className="page-title-container">
        <Row className="g-0">
          {/* Title Start */}
          <Col className="col-auto mb-3 mb-sm-0 me-auto">
            <div className="muted-link pb-1 d-inline-block hidden breadcrumb-back cursor-pointer" onClick={() => history.goBack()}>
              <CsLineIcons icon="chevron-left" size="13" />
              <span className="align-middle text-small ms-1">Atrás</span>
            </div>
          </Col>
          {/* Title End */}
        </Row>
      </div>
      <Col xxl="10">
        <Row>
          <motion.div initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} whileTap={{ scale: 0.95 }} transition={{ duration: 0.5 }}>
            <Col className="mb-5">
              {/* h-lg-100 */}
              <Card className="sh-45 position-relative bg-theme">
                <img src="/img/illustration/database.webp" className="card-img h-100 position-absolute theme-filter" alt="card image" />
                <div className="card-img-overlay d-flex flex-column justify-content-end bg-transparent">
                  <div className="mb-4">
                    <div className="cta-1 mb-2 w-75 w-sm-50 text-primary">Integraciones</div>
                    <div className="w-50 text-alternate">
                      Explora nuestras integraciones y conecta tu tienda en minutos. Consulta la documentación para configurar cada integración fácilmente.
                    </div>
                  </div>
                </div>
              </Card>
            </Col>
          </motion.div>
        </Row>
        {/* Guildes Start  */}
        <Row className="g-0 gx-3 gy-3">
          {plugins.length > 0 && (
            <>
              <PluginCards item={{ name: 'API', state: true, icon: '/img/illustration/icon-api.png' }} />
              {plugins?.map((item, index) => (
                <PluginCards item={item} key={index} />
              ))}
            </>
          )}
        </Row>
        {/* Guildes End */}
      </Col>
    </>
  );
};

export default Integrations;
